import React, { useState } from 'react';
import PrePrimaryIntro from './PrePrimaryIntro';
import './PrePrimaryOlympiad.css';

const PrePrimaryOlympiad = () => {
  const [showFullPage, setShowFullPage] = useState(false);
  const [formData, setFormData] = useState({
    studentName: '',
    parentName: '',
    age: '',
    grade: '',
    school: '',
    coordinatorName: '',
    coordinatorPhone: '',
    coordinatorEmail: '',
    phone: '',
    email: '',
    address: '',
    acceptTerms: false
  });

  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [registrationSuccess, setRegistrationSuccess] = useState(false);

  const grades = ['Nursery', 'LKG', 'UKG', 'Kindergarten'];

  const benefits = [
    { icon: '📚', title: 'Free Practice Book', desc: 'Every child gets 1 free practice book' },
    { icon: '🏅', title: 'Participation Certificate', desc: 'Certificate for all participants' },
    { icon: '🏆', title: 'Medal & Trophy', desc: 'Ranked students win medals & trophies' },
    { icon: '🎁', title: 'Exciting Prizes', desc: 'Special prizes for top performers' },
    { icon: '💰', title: 'One Time Fee', desc: 'Only ₹200 - No hidden charges' },
    { icon: '⭐', title: 'Expert Evaluation', desc: 'Professional assessment' }
  ];

  const prizes = [
    { rank: '1st Rank', prize: 'Gold Medal + Trophy + Gift Hamper + Certificate', color: '#ffd700' },
    { rank: '2nd Rank', prize: 'Silver Medal + Trophy + Gift + Certificate', color: '#c0c0c0' },
    { rank: '3rd Rank', prize: 'Bronze Medal + Trophy + Certificate', color: '#cd7f32' },
    { rank: 'Participation', prize: 'Certificate + Free Practice Book', color: '#4caf50' }
  ];

  const coordinatorBenefits = [
    { icon: '👥', title: 'School Coordinator', desc: 'Appointed from your school' },
    { icon: '📜', title: 'Special Certificate', desc: 'Recognition certificate for coordinator' },
    { icon: '🎓', title: 'Leadership Role', desc: 'Manage Olympiad in your school' },
    { icon: '🏅', title: 'Appreciation Gift', desc: 'Special gift from Amfia' }
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const validateForm = () => {
    if (!formData.studentName.trim()) {
      setError('Student name is required');
      return false;
    }
    if (!formData.parentName.trim()) {
      setError('Parent name is required');
      return false;
    }
    if (!formData.age) {
      setError('Age is required');
      return false;
    }
    if (!formData.grade) {
      setError('Grade is required');
      return false;
    }
    if (!formData.phone || formData.phone.length < 10) {
      setError('Valid phone number is required');
      return false;
    }
    if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      setError('Valid email is required');
      return false;
    }
    if (!formData.acceptTerms) {
      setError('Please accept the terms and conditions');
      return false;
    }
    return true;
  };

  const handlePayment = async () => {
    if (!validateForm()) return;

    setLoading(true);
    setError('');

    setTimeout(() => {
      setLoading(false);
      setShowPopup(true);
      setRegistrationSuccess(true);
      console.log('Registration Data:', formData);
    }, 1500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePayment();
  };

  // if (!showFullPage) {
  //   return <PrePrimaryIntro onKnowMore={() => setShowFullPage(true)} />;
  // }

  if (registrationSuccess && !showPopup) {
    return (
      <div className="ppo-success-page">
        <div className="ppo-success-card">
          <div className="ppo-success-animation">🎉</div>
          <h2 className="ppo-success-title">Registration Successful!</h2>
          <p className="ppo-success-message">Your child has been successfully registered for the Pre-Primary Olympiad 2025!</p>
          <div className="ppo-success-details">
            <p>📚 Free practice book will be delivered soon</p>
            <p>🏅 Certificate will be provided on exam day</p>
            <p>📧 Confirmation sent to: {formData.email}</p>
            {formData.coordinatorName && (
              <p>👥 Coordinator {formData.coordinatorName} will receive certificate</p>
            )}
          </div>
          <button onClick={() => window.location.reload()} className="ppo-success-btn">
            Register Another Student
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ppo-container">
      {/* Hero Section */}
      <div className="ppo-hero-section">
        <div className="ppo-hero-badge">🌟 Limited Registrations Open 🌟</div>
        <h1 className="ppo-hero-title">
          Pre-Primary <span className="ppo-highlight">Olympiad</span> 2026
        </h1>
        <p className="ppo-hero-subtitle">
          Give your child a head start in the journey of excellence
        </p>
        <div className="ppo-price-card">
          <div className="ppo-price-badge">Special Launch Offer</div>
          <div className="ppo-price-amount">
            ₹250 <span className="ppo-price-old">₹999</span>
          </div>
          <div className="ppo-price-note">One Time Registration Fee • No Hidden Charges</div>
        </div>
      </div>

      {/* School Exam Information */}
      <div className="ppo-exam-section">
        <h2 className="ppo-section-title">📚 Exam Conducted in Your School 📚</h2>
        <div className="ppo-exam-card">
          <div className="ppo-exam-content">
            <div className="ppo-exam-icon">🏫</div>
            <div className="ppo-exam-text">
              <h3 className="ppo-exam-heading">Convenient & Comfortable</h3>
              <p className="ppo-exam-description">We conduct the Olympiad exam right in your child's school during school hours.</p>
              <ul className="ppo-exam-list">
                <li>✅ No need to travel to external centers</li>
                <li>✅ Comfortable environment for young children</li>
                <li>✅ Familiar surroundings reduce exam anxiety</li>
                <li>✅ School teachers supervise the exam</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Coordinator Section */}
      <div className="ppo-coordinator-section">
        <h2 className="ppo-section-title">👥 Become a School Coordinator 👥</h2>
        <div className="ppo-coordinator-grid">
          {coordinatorBenefits.map((benefit, index) => (
            <div className="ppo-coordinator-card" key={index}>
              <div className="ppo-coordinator-icon">{benefit.icon}</div>
              <h3 className="ppo-coordinator-title">{benefit.title}</h3>
              <p className="ppo-coordinator-desc">{benefit.desc}</p>
            </div>
          ))}
        </div>
        <div className="ppo-coordinator-highlight">
          <div className="ppo-coordinator-badge">🎯 Special Recognition</div>
          <p className="ppo-coordinator-text">Each school can appoint a coordinator who will receive a <strong>Special Certificate of Appreciation</strong> from Amfia Education for their valuable contribution in organizing the Olympiad.</p>
        </div>
      </div>

      {/* Annual Function Ceremony */}
      <div className="ppo-ceremony-section">
        <h2 className="ppo-section-title">🎉 Grand Prize Distribution Ceremony 🎉</h2>
        <div className="ppo-ceremony-card">
          <div className="ppo-ceremony-content">
            <div className="ppo-ceremony-text">
              <h3 className="ppo-ceremony-heading">Celebrate at Your School's Annual Function!</h3>
              <p className="ppo-ceremony-description">An <strong>Amfia Education Team Member</strong> will personally attend your school's annual function to:</p>
              <ul className="ppo-ceremony-list">
                <li>🏆 Distribute certificates to all participants</li>
                <li>🥇 Award medals to ranked students</li>
                <li>🏅 Present trophies to top performers</li>
                <li>📜 Honor the school coordinator with certificate</li>
                <li>📸 Professional photography of the ceremony</li>
              </ul>
              <div className="ppo-ceremony-note">
                <strong>✨ Special Note:</strong> This makes the occasion even more memorable for students 
                as they receive recognition in front of their peers and parents!
              </div>
            </div>
            <div className="ppo-ceremony-icon">🎭</div>
          </div>
        </div>
      </div>

      {/* Benefits Grid */}
      <div className="ppo-benefits-section">
        <h2 className="ppo-section-title">What Your Child Gets</h2>
        <div className="ppo-benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="ppo-benefit-card" key={index}>
              <div className="ppo-benefit-icon">{benefit.icon}</div>
              <h3 className="ppo-benefit-title">{benefit.title}</h3>
              <p className="ppo-benefit-desc">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Prizes Section */}
      <div className="ppo-prizes-section">
        <h2 className="ppo-section-title">🏆 Exciting Prizes & Rewards 🏆</h2>
        <div className="ppo-prizes-grid">
          {prizes.map((prize, index) => (
            <div className="ppo-prize-card" style={{ borderTopColor: prize.color }} key={index}>
              <div className="ppo-prize-rank">{prize.rank}</div>
              <div className="ppo-prize-desc">{prize.prize}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Registration Form */}
      <div className="ppo-form-section" id="register">
        <h2 className="ppo-section-title">Register Now</h2>
        <div className="ppo-form-card">
          {error && <div className="ppo-error-message">{error}</div>}
          
          <form onSubmit={handleSubmit} className="ppo-form">
            <h3 className="ppo-form-subtitle">Student Details</h3>
            
            <div className="ppo-form-row">
              <div className="ppo-form-group">
                <label className="ppo-form-label">Student's Full Name *</label>
                <input
                  type="text"
                  name="studentName"
                  value={formData.studentName}
                  onChange={handleChange}
                  placeholder="Enter student's name"
                  className="ppo-form-input"
                />
              </div>
              <div className="ppo-form-group">
                <label className="ppo-form-label">Parent's Name *</label>
                <input
                  type="text"
                  name="parentName"
                  value={formData.parentName}
                  onChange={handleChange}
                  placeholder="Enter parent's name"
                  className="ppo-form-input"
                />
              </div>
            </div>

            <div className="ppo-form-row">
              <div className="ppo-form-group">
                <label className="ppo-form-label">Age *</label>
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  placeholder="e.g., 4"
                  min="3"
                  max="6"
                  className="ppo-form-input"
                />
              </div>
              <div className="ppo-form-group">
                <label className="ppo-form-label">Grade/Class *</label>
                <select name="grade" value={formData.grade} onChange={handleChange} className="ppo-form-select">
                  <option value="">Select Grade</option>
                  {grades.map(grade => (
                    <option key={grade} value={grade}>{grade}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="ppo-form-group">
              <label className="ppo-form-label">School Name</label>
              <input
                type="text"
                name="school"
                value={formData.school}
                onChange={handleChange}
                placeholder="Enter school name"
                className="ppo-form-input"
              />
            </div>

            <div className="ppo-form-row">
              <div className="ppo-form-group">
                <label className="ppo-form-label">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="10-digit mobile number"
                  maxLength="10"
                  className="ppo-form-input"
                />
              </div>
              <div className="ppo-form-group">
                <label className="ppo-form-label">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  className="ppo-form-input"
                />
              </div>
            </div>

            <div className="ppo-form-group">
              <label className="ppo-form-label">Address</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter complete address for book delivery"
                rows="3"
                className="ppo-form-textarea"
              />
            </div>

            <h3 className="ppo-form-subtitle">School Coordinator Details (Optional)</h3>
            <div className="ppo-coordinator-note">
              <p>💡 Appoint a coordinator from your school to receive special recognition certificate</p>
            </div>

            <div className="ppo-form-row">
              <div className="ppo-form-group">
                <label className="ppo-form-label">Coordinator Name</label>
                <input
                  type="text"
                  name="coordinatorName"
                  value={formData.coordinatorName}
                  onChange={handleChange}
                  placeholder="Enter coordinator name"
                  className="ppo-form-input"
                />
              </div>
              <div className="ppo-form-group">
                <label className="ppo-form-label">Coordinator Phone</label>
                <input
                  type="tel"
                  name="coordinatorPhone"
                  value={formData.coordinatorPhone}
                  onChange={handleChange}
                  placeholder="Coordinator's mobile number"
                  className="ppo-form-input"
                />
              </div>
            </div>

            <div className="ppo-form-group">
              <label className="ppo-form-label">Coordinator Email</label>
              <input
                type="email"
                name="coordinatorEmail"
                value={formData.coordinatorEmail}
                onChange={handleChange}
                placeholder="Coordinator's email address"
                className="ppo-form-input"
              />
            </div>

            <div className="ppo-checkbox-group">
              <input
                type="checkbox"
                name="acceptTerms"
                checked={formData.acceptTerms}
                onChange={handleChange}
                className="ppo-checkbox"
              />
              <label className="ppo-checkbox-label">
                I agree to the terms and conditions. I understand this is a one-time fee of ₹200 
                with no other charges.
              </label>
            </div>

            <button type="submit" className="ppo-register-btn" disabled={loading}>
              {loading ? 'Processing...' : 'Register & Pay ₹200'}
            </button>
          </form>
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="ppo-popup-overlay">
          <div className="ppo-popup-content">
            <div className="ppo-popup-icon">✅</div>
            <h2 className="ppo-popup-title">Registration Successful!</h2>
            <p className="ppo-popup-message">Your child has been registered for the Pre-Primary Olympiad!</p>
            <div className="ppo-popup-details">
              <p>📚 A free practice book will be sent to your address</p>
              <p>🏅 Certificate & Medal will be given at annual function</p>
              <p>📧 Confirmation email sent to: {formData.email}</p>
              {formData.coordinatorName && (
                <p>👥 Coordinator {formData.coordinatorName} will receive appreciation certificate</p>
              )}
              <p>🎉 Amfia team will attend your school's annual function</p>
            </div>
            <button onClick={() => setShowPopup(false)} className="ppo-popup-btn">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrePrimaryOlympiad;